/**
 * Category key used by AnnotationsPanel's filter UI to identify scope filters
 * within the generic `SelectedFilter[]` array. Shared so consumers can extract
 * the currently-selected scopes without depending on the panel module.
 */
export const SCOPE_CATEGORY_KEY = "scope";
